import React, { useState } from 'react';
import { Typography, IconButton } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
 
const PortfolioFaultSummary = ({ portfolioLevelText, selectedPortfolioFaultStations, selectedYear, portfolioStationsList,  portfolioFaultData }) => {
  const [expanded, setExpanded] = useState(false);
  const showCollapse = selectedPortfolioFaultStations.length > 15;
 
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
 
  const getProcessedStationsList = () => {
    if (portfolioStationsList === '<span style="color: #999;">No stations available</span>') {
      return portfolioStationsList;
    }
 
    const stationsArray = portfolioStationsList.split('</span>')
      .filter(station => station.trim())
      .map(station => station + '</span>');
 
    if (!showCollapse || expanded) {
      return stationsArray.join('');
    }
 
    const visibleStations = stationsArray.slice(0, 5).join('');
    const remainingCount = stationsArray.length - 5;
    return visibleStations + ` <span class="station-badge">+${remainingCount} more...</span>`;
  };
 
  return (
    <div className="portfolio-summary">
      <Typography className="portfolioFaultLevel" variant="subtitle1">
        <strong>📍 Portfolio Selection: {portfolioLevelText}</strong>
      </Typography>
      <Typography className="portfolioFaultLevel" variant="subtitle1">
        <strong>
          📌 Total Stations: {selectedPortfolioFaultStations.length}
          {selectedYear && ` | 📅 Year: ${selectedYear}`}
        </strong>
      </Typography>
      {selectedPortfolioFaultStations.length === 1 && portfolioFaultData.length > 0 && (() => {
        const selectedStation = selectedPortfolioFaultStations[0];
        const relevantFaults = portfolioFaultData.filter(fault =>
          fault.stationId === selectedStation
        );
 
        let totalFaults = 0;
        let criticals = 0;
        let warnings = 0;
 
        relevantFaults.forEach(fault => {
          fault.faultTypes?.forEach(type => {
            const typeName = type.faultType?.toLowerCase();
            const count = type.count || 0;
            totalFaults += count;
            if (typeName === 'critical') criticals += count;
            else if (typeName === 'warning') warnings += count;
          });
        });
 
        return (
          <div style={{ marginTop: '5px' }}>
            <Typography className="portfolioFaultLevel" variant="subtitle1">
              <strong>📊 Total Faults: {totalFaults} &nbsp;| &nbsp;</strong>
              <strong>🚨 Criticals: {criticals} &nbsp;| &nbsp;</strong>
              <strong>⚠️ Warnings: {warnings}</strong>
            </Typography>
          </div>
        );
      })()}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
        <Typography
          className="portfolioFaultLevel"
          variant="subtitle1"
          component="div"
          style={{ flex: 1 }}
          dangerouslySetInnerHTML={{ __html: `<strong>🌏 Stations:</strong> ${getProcessedStationsList()}` }}
        />
        {showCollapse && (
          <IconButton
            onClick={handleExpandClick}
            size="small"
            style={{
              marginTop: '4px',
              padding: '4px'
            }}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
      </div>
    </div>
  );
};
 
export default PortfolioFaultSummary;